import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntegrationPeopleHRComponent } from './integration-people-hr/integration-people-hr.component';
import { IntegrationSlackCancellationComponent } from './integration-slack/integration-slack-cancellation/integration-slack-cancellation.component';
import { IntegrationSlackCompletionComponent } from './integration-slack/integration-slack-completion/integration-slack-completion.component';
import { IntegrationSlackComponent } from './integration-slack/integration-slack.component';
import { IntegrationVincereComponent } from './integration-vincere/integration-vincere.component';
import { CompanyDashboardIntegrationsComponent } from './admin-integrations-navigation/admin-integrations-navigation.component';
import { IntegrationActiveDirectoryComponent } from './integration-active-directory/integration-active-directory.component';
import { CreateDirectoryComponent } from './integration-active-directory/create-directory/create-directory.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { RouterModule } from '@angular/router';
import { IntegrationSagehrComponent } from './integration-sagehr/integration-sagehr.component';
import { IntegrationZendeskComponent } from './integration-zendesk/integration-zendesk.component';
import { IntegrationTriNetComponent } from './integration-trinet/integration-trinet.component';
import { MomentModule } from 'ngx-moment';
import { IntegrationMergeComponent } from 'app/admin/admin-modules/admin-integrations/admin-integrations-components/integration-merge/integration-merge.component';
import { TranslateModule } from '@ngx-translate/core';
import { IntegrationEvaluagentComponent } from './integration-evaluagent/integration-evaluagent.component';
import { PaginationModule } from '@app/shared/pagination/pagination.module';
import { IntegrationAbsorblmsComponent } from './integration-absorblms/integration-absorblms.component';
import { IntegrationZendeskQaComponent } from './integration-zendesk-qa/integration-zendesk-qa.component';


const components = [
  CompanyDashboardIntegrationsComponent,
  IntegrationSlackComponent,
  IntegrationSlackCompletionComponent,
  IntegrationSlackCancellationComponent,
  IntegrationPeopleHRComponent, 
  IntegrationVincereComponent,
  IntegrationZendeskComponent,
  IntegrationActiveDirectoryComponent,
  IntegrationTriNetComponent,
  CreateDirectoryComponent,
  IntegrationSagehrComponent,
  IntegrationEvaluagentComponent,
  IntegrationAbsorblmsComponent,
  IntegrationMergeComponent,
  IntegrationZendeskQaComponent
];

@NgModule({
  declarations: components,
  exports: components,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TooltipModule,
    MomentModule,
    TranslateModule,
    PaginationModule
  ]
})
export class AdminIntegrationsComponentsModule { }
